import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class RecommendedHotelsService {
  constructor(private http: HttpClient) {}

  /**
   * Get hotels recommended by id hotel asynchronously
   * @return {Object}
   */
  public getRecommendedHotels(entityId: string, params: any): Observable<any> {
    return this.http.get(`/hotels/async/recommended/hotels/${entityId}${params}`);
  }
}
